import { render, staticRenderFns } from "./TopDashboardBar.vue?vue&type=template&id=1819e186"
import script from "./TopDashboardBar.vue?vue&type=script&lang=js"
export * from "./TopDashboardBar.vue?vue&type=script&lang=js"
import style0 from "./TopDashboardBar.vue?vue&type=style&index=0&id=1819e186&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports